import { Link } from "react-router-dom";
import FeedbackForm from "@/pages/contact/components/FeedbackForm";

const contactItems = [
  {
    icon: "ri-mail-line",
    label: "邮箱",
    value: "feedback@neighborwife.example.com",
    hint: "内容建议、版权反馈、合作咨询",
  },
  {
    icon: "ri-weibo-fill",
    label: "微博",
    value: "@邻居的妻子影视大全",
    hint: "关注最新剧集动态与专题推荐",
  },
  {
    icon: "ri-wechat-fill",
    label: "微信公众号",
    value: "邻居的妻子影视",
    hint: "搜索公众号名称即可关注",
  },
  {
    icon: "ri-time-line",
    label: "回复时间",
    value: "工作日 10:00 - 18:00",
    hint: "我们会尽快处理你的留言",
  },
];

export default function Contact() {
  return (
    <div className="w-full">
      <div className="bg-primary-950">
        <div className="w-full px-4 md:px-8 pt-6 pb-12">
          <nav className="flex items-center gap-1.5 text-xs md:text-sm text-background-300/80 mb-4">
            <Link to="/" className="hover:text-accent-400 transition-colors cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line text-base"></i>
            <span className="text-background-100 font-medium">联系我们</span>
          </nav>
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-background-50">联系我们</h1>
          <p className="mt-3 text-sm md:text-base text-background-200/90 max-w-2xl leading-relaxed">
            无论你是想推荐作品、反馈问题，还是有内容与版权相关的事宜，都欢迎通过下面的方式与我们取得联系。
          </p>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr,1.2fr] gap-8 lg:gap-12">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-2 mb-6">
              <span className="w-1 h-5 rounded-full bg-accent-500 inline-block"></span>
              联系方式
            </h2>
            <div className="space-y-4">
              {contactItems.map((c) => (
                <div
                  key={c.label}
                  className="flex items-start gap-4 p-4 rounded-lg bg-background-100 border border-background-200"
                >
                  <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                    <i className={`${c.icon} text-xl`}></i>
                  </span>
                  <div className="min-w-0">
                    <div className="text-xs text-foreground-500">{c.label}</div>
                    <div className="mt-0.5 text-sm font-semibold text-foreground-950 break-all">{c.value}</div>
                    <div className="mt-1 text-xs text-foreground-500">{c.hint}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 rounded-lg bg-secondary-100 border border-secondary-200 p-5 text-sm text-secondary-900 leading-relaxed">
              <i className="ri-information-line mr-1"></i>
              本站为内容展示与剧情介绍平台，不提供在线播放、下载或会员服务，相关咨询恕无法受理，敬请理解。
            </div>
          </div>

          <div>
            <FeedbackForm />
          </div>
        </div>
      </div>
    </div>
  );
}